import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=c3127da0&"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js&"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&id=c3127da0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports